export enum MenuNavigationViewType {
  Top = 'top',
  Side = 'side',
  TopAndSide = 'top-and-side',
}
